"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allocatePaymentTermAmounts = allocatePaymentTermAmounts;
/**
 * Allocate payment-term weights onto a target invoice total so split amounts
 * always sum to the line-items total (GST-inclusive or exclusive).
 *
 * Prefers budgetPercent when every term has one; otherwise uses provisional
 * amounts (percent-of-target when present, else budgetAmount) and scales.
 * Last row absorbs cent rounding so the sum matches target exactly.
 */
function allocatePaymentTermAmounts(terms, targetTotal) {
    const n = terms.length;
    if (n === 0)
        return [];
    const target = Math.round(Math.max(0, Number(targetTotal) || 0) * 100) / 100;
    if (target <= 0)
        return terms.map(() => 0);
    const percents = terms.map((term) => {
        const percent = Number(term.budgetPercent);
        return Number.isFinite(percent) && percent > 0 ? percent : null;
    });
    const allHavePercent = percents.every((percent) => percent != null);
    let raw;
    if (allHavePercent) {
        const sumPct = percents.reduce((sum, percent) => sum + (percent ?? 0), 0);
        const scale = sumPct > 0 ? 100 / sumPct : 0;
        raw = percents.map((percent) => (target * ((percent ?? 0) * scale)) / 100);
    }
    else {
        const provisional = terms.map((term) => {
            const percent = Number(term.budgetPercent);
            if (Number.isFinite(percent) && percent > 0) {
                return (target * percent) / 100;
            }
            const amount = Number(term.budgetAmount);
            return Number.isFinite(amount) && amount > 0 ? amount : 0;
        });
        const sum = provisional.reduce((a, b) => a + b, 0);
        raw =
            sum > 0
                ? provisional.map((amount) => (amount / sum) * target)
                : terms.map(() => target / n);
    }
    const rounded = raw.map((amount) => Math.round(amount * 100) / 100);
    const roundedSum = rounded.reduce((a, b) => a + b, 0);
    const diff = Math.round((target - roundedSum) * 100) / 100;
    rounded[n - 1] = Math.round((rounded[n - 1] + diff) * 100) / 100;
    return rounded;
}
